<template>
    <div class="buttons-container"
        v-if="step.status_actions_rendered"
        :data-links-target="linkTarget"
        >
        <template
            v-for="action_btn in step.status_actions_rendered"
            :key="action_btn.index"
            >
            
            <!-- {# -<pre>{{ action_btn.result_event_type | print_r }}</pre> #} -->
            <a 
                v-if="'relaxed' == stepsMode || step.active"
                :href="action_btn.url" 

                class="btn btn--medium btn--grey"
                
                :data-redirect="getRedirectNode(action_btn)"
                :data-iframe-src="action_btn.url"
                @click="buttonAction(action_btn, $event)"
                >
                <template 
                    v-if="'text-button' == action_btn.button_type"
                    >{{ action_btn.button_text }}</template>
                    <span 
                        v-else-if="'icon-button' == action_btn.button_type"
                        :class="action_btn.button_icon"></span>
            </a>

            <span 
                v-else
                class="btn btn--medium btn--grey">
                <template 
                    v-if="'text-button' == action_btn.button_type"
                    >{{ action_btn.button_text }}</template>
                <span 
                    v-else-if="'icon-button' == action_btn.button_type"
                    :class="action_btn.button_icon"
                    ></span>
            </span>
            
        </template>
    </div>

</template>

<script>
export default {
    name: 'StepButtonsComponent',
    props: {
        step: {
            type: Object,
            default: {},
            required: true
        },
        linkTarget: {
            type: String,
            default: 'redirect',
            required: true,
        },
        stepsMode: {
            type: String,
            default: 'relaxed',
            required: true
        }
    },

    data() {
        return {

        }
    },

    inject: {
        detailsViewId: {
            from: 'detailsViewId',
            default: false
        }
    },

    methods: {
        getRedirectNode( action_btn ) {
            if ( ! action_btn.result_event ) return null
            if ( 'close-module' == action_btn.result_event ) {
                return 'close-module'
            }
            return decodeURI(action_btn.result_event)
        },

        buttonAction( action_btn, e ) {
            if ( this.detailsViewId ) {

                e.preventDefault()

                const a = e.currentTarget

                this.emitter.emit('topStepperButtonClick', {
                    'button': a,
                    'linksTarget': this.linkTarget,
                    'href': action_btn.url,
                    'event': e,
                    'redirect': this.getRedirectNode( action_btn )
                })

                return false

            }
        }
    }
}
</script>